import { atom } from "recoil";

const TerminalFilterAtom = atom({
    default: 'all',
    key: 'terminalFilterAtom'
})

export default TerminalFilterAtom;